import React, { useState, useEffect } from "react"
import { SentrySetup } from "./src/hooks/sentry-setup"
import { Authenticate } from "./src/hooks/authenticate"
import { isOutdatedBrowser } from "./src/utils/browser-detection"
import OutdatedBrowserNotice from "./src/components/outdated-browser-notice"

// Create a proper React component to use hooks
const PageWrapper = ({ element, props }) => {
  const [isOutdated, setIsOutdated] = useState(false);
  const [showNotice, setShowNotice] = useState(false);
  
  useEffect(() => {
    // Check for outdated browser after component mounts
    if (typeof window !== 'undefined') {
      const outdated = isOutdatedBrowser();
      setIsOutdated(outdated);
      setShowNotice(outdated);
    }
  }, []);
  
  const handleContinue = () => {
    setShowNotice(false);
  };
  
  return (
    <Authenticate {...props}>
      <SentrySetup {...props}>
        {showNotice && <OutdatedBrowserNotice onContinue={handleContinue} />}
        {element}
      </SentrySetup>
    </Authenticate>
  );
}

// Create the wrapPageElement function that Gatsby expects
const wrapPageElement = ({ element, props }) => {
  return <PageWrapper element={element} props={props} />;
};

export default wrapPageElement
